module.exports = __webpack_public_path__ + "img/cart_icon.688c43c6.png";